<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>{{ $tc('general.n0') }}</th>
          <th>{{ $tc('settings.logo') }}</th>
          <th>{{ $tc('club.club_name') }}</th>
          <th>{{ $tc('club.short_name') }}</th>
          <th v-if="tournamentCompetitors">{{ $tc('club.number_of_competitors') }}</th>
          <th>{{ $tc('form.city') }}</th>
          <th>{{ $tc('form.address') }}</th>
          <th>{{ $tc('form.email') }}</th>
          <th>{{ $tc('form.website') }}</th>
          <th>{{ $tc('form.contact_person') }}</th>
          <th>{{ $tc('form.mobile') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="item.id">
          <td>{{ index + 1 }}.</td>
          <td style="width: 80px">
            <div class="image">
              <img :src="$file('avatars', item.logo)" style="width: 75px; height: 75px; object-fit: cover;" class="image" />
            </div>
          </td>
          <td>{{ item.name }}</td>
          <td>{{ item.shortName }}</td>
          <td v-if="tournamentCompetitors">{{ getTournamentCompetitorsCount(item.id) }}</td>
          <td>{{ item.city }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.website }}</td>
          <td>{{ item.contact }}</td>
          <td>{{ item.mobile }}</td>
        </tr>
      </tbody>
    </table>
    <div v-if="footerText" style="margin-top: 15px; text-align: right; font-size: 16px; font-weight: bold; margin-bottom: 15px;">{{ footerText }}</div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: null
    },

    tournamentCompetitors: {
      type: Array,
      default: null
    },

    footerText: {
      type: String,
      default: null
    }
  },

  methods: {
    getTournamentCompetitorsCount (clubId) {
      const uniqueIds = new Set()
      this.tournamentCompetitors.forEach(competitor => {
        if (parseInt(competitor.club?.id) === parseInt(clubId)) {
          if (competitor.competitorId) {
            uniqueIds.add(competitor.competitorId)
          }
          if (competitor.competitorTwoId) {
            uniqueIds.add(competitor.competitorTwoId)
          }
          if (competitor.competitorThreeId) {
            uniqueIds.add(competitor.competitorThreeId)
          }
          if (competitor.competitorFourId) {
            uniqueIds.add(competitor.competitorFourId)
          }
        }
      })
      return uniqueIds.size
    }
  }
}
</script>
